import { FormattedMessage } from 'react-intl'
import { keys } from 'lodash'
import { useQuery } from '@apollo/client'

import { ErrorMessage } from 'components/v2/ErrorMessage'
import { GET_ITEMS_AUTOCOMPLETE } from 'resolvers/items'
import { isInStockError } from 'utils/error'

export const InStockError = ({ errors = [] }): TSFixMe => {
  const { data: itemsData } = useQuery(GET_ITEMS_AUTOCOMPLETE, {
    variables: {
      limit: 100000
    }
  })
  const items = (itemsData && itemsData.itemsAutocomplete) || []

  if (errors && errors.length > 0) {
    return (
      <div>
        {/* @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message*/}
        {errors.map((error = {}, index): TSFixMe => {
          if (isInStockError(error)) {
            try {
              // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
              const parsedError = JSON.parse(error.param)
              const itemId = keys(parsedError)[0]
              const stockValue = parsedError[itemId]
              const item = items.find(({ id }: TSFixMe): TSFixMe => itemId === id)

              return (
                <ErrorMessage key={index}>
                  <FormattedMessage
                    id="spanish.inventories.inStockError"
                    defaultMessage="{itemName} - Stock actual: {stockValue}"
                    values={{
                      itemName: (item && item.name) || 'Unknown',
                      stockValue
                    }}
                  />
                </ErrorMessage>
              )
            } catch (ex) {
              // eslint-disable-next-line no-console
              console.error(ex)
            }
          }

          return null
        })}
      </div>
    )
  }

  return null
}
